import { AfterViewInit, Injectable } from "@angular/core";
import { BaseTemplate } from "../../../../../../shared/baseTemplate";

@Injectable({
  providedIn: 'root'
})

export class BasePhysicalTemplate extends BaseTemplate
  implements AfterViewInit {
  productImage = null;
  maxQuantity = 0;
  maxQuantityPerSale = 0;

  /** @returns {number} the raw product price without currency conversion */
  getRawPrice() {
    const price = this.productObject['PhysicalProductExtraInfo']['price'];
    return Number(price)
  }

  async quantityChange(val: any) {
    this.price = this.getRawPrice();
    this.quantity += val;

    this.quantity = this.quantity < 0 ? 0 : this.quantity;
    this.quantity = this.quantity > this.maxQuantityPerSale ? this.maxQuantityPerSale : this.quantity;

    this.vpihs.quantity = this.quantity;
    this.calculateSubTotalAmount();
  }

  calculateSubTotalAmount() {
    this.subtotal = this.quantity * this.price;

    return this.vpihs.getExchangedValue(
      this.subtotal,
      this.getProductValueByFieldName("Currency")
    );
  }
  /**
   * @description override because we need to calculate quantity
   */
  calculateTaxes() {
    const taxes = this.getNewProductValueByFieldName("taxes", "ProductTax");
    const type = this.getNewProductValueByFieldName("type", "ProductTax");
    if (!taxes) {
      this.taxes = 0;
      return this.taxes;
    }
    let taxesValue = 0;
    if (type && type === "Percentage") {
      const taxesObjectValue = Number(taxes) || 0;
      let subtotal = this.getRawPrice() * this.quantity;

      taxesValue = (this.getExchangedValue(Number(subtotal), this.vpihs.currency) * taxesObjectValue) / 100;
    } else {
      taxesValue = this.getExchangedValue(Number(taxes), this.vpihs.currency);
    }
    console.log(taxesValue, "taxesss textesd");
    return (this.taxes = taxesValue);
  }

  ngAfterViewInit() {
    this.productImage = this.getProductValueByFieldName("Product image");
    super.ngAfterViewInit();
  }
}
